export enum VehicleType {
  PKW = "PKW",
  LCV = "LCV",
  GLW = "GLW",
}
